module.exports = __webpack_public_path__ + "fonts/SteelfishRg-Bold.9487bcb0.woff";